import {
  citiesSelectsDataLoading,
  citiesSelectsData,
} from '../../redux/features/dashboard/dashboardSelectors';
import { validationSchema } from '../validationSchema';
import { genderRadioData } from './add-client-mock';

export const initialValues = {
  agent_country_id: '',
  agent_city: '',
  first_name: '',
  last_name: '',
  gender: '',
  agent_email: '',
  agent_phone: '',
  password: '',
  password_confirmation: '',
};

export const validationSchemaRegistration = {
  agent_country_id: validationSchema.select,
  agent_city: validationSchema.default,
  first_name: validationSchema.firstName,
  last_name: validationSchema.lastName,
  gender: validationSchema.default,
  agent_email: validationSchema.email,
  agent_phone: validationSchema.phone,
  password: validationSchema.newPassword,
  password_confirmation: validationSchema.repeatPassword,
};

export const mock = [
  {
    id: 8,
    placeholder: 'Your country',
    name: 'agent_country_id',
    fieldType: 'select',
    isRequired: true,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 9,
    placeholder: 'Your city',
    name: 'agent_city',
    fieldType: 'selectDepedent',
    selectDepedentData: citiesSelectsData,
    selectDepedentDataLoading: citiesSelectsDataLoading,
    isRequired: true,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 10,
    placeholder: 'First name',
    name: 'first_name',
    fieldType: 'text',
    isRequired: true,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 11,
    placeholder: 'Last name',
    name: 'last_name',
    fieldType: 'text',
    isRequired: true,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 12,
    placeholder: 'Gender',
    name: 'gender',
    fieldType: 'radio',
    isRequired: true,
    radioList: genderRadioData,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 13,
    placeholder: 'Your email',
    name: 'agent_email',
    fieldType: 'text',
    isRequired: true,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 14,
    placeholder: 'Your phone',
    name: 'agent_phone',
    fieldType: 'text',
    isRequired: true,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 15,
    placeholder: 'Password',
    name: 'password',
    type: 'password',
    fieldType: 'text',
    isRequired: true,
    classNames: 'w-60 sm:w-80',
  },
  {
    id: 16,
    placeholder: 'Confirm password',
    name: 'password_confirmation',
    type: 'password',
    fieldType: 'text',
    isRequired: true,
    classNames: 'mb-5 w-60 sm:w-80',
  },
];
